import React, { Component } from 'react'
import classnames from 'classnames'
import styles from './progressSteps.module.scss'
import PropTypes from 'prop-types'
import { strings } from '../utils/translations'

export default class ProgressSteps extends Component
{
    constructor(props)
    {
        super(props)

        this.state =
        {
            
        }
    }

    render()
    {
        return (
            <div className={styles.progressBar}>
                <div className={ classnames([styles.progress, {[styles.active]: this.props.activeStepIndex >= 0}]) }>
                    {
                        (this.props.numDoors && this.props.numDoors > 0) ?
                        <>
                            <b>{ this.props.numDoors }</b> {this.props.numDoors > 1 ? strings('doors').toLowerCase() : strings('door')}
                        </> : null
                    }
                </div>
                <div className={ classnames([styles.progress, {[styles.active]: this.props.activeStepIndex >= 1}]) }>
                    {
                        (this.props.numUsers && this.props.numUsers > 0) ?
                        <>
                            <b>{ this.props.numUsers }</b> {this.props.numUsers > 1 ? strings('users').toLowerCase() : strings('user')}
                        </> : null
                    }
                </div>
                <div className={ classnames([styles.progress, {[styles.active]: this.props.activeStepIndex >= 2}]) }></div>
            </div>
        )
    }
}

ProgressSteps.propTypes =
{
    activeStepIndex: PropTypes.number
}